import { CONFIG } from "../config";
import type { CatalogEntry } from "./catalog";

/** The hardcoded starter song, else the simplest non-drill piece, else null
 *  (cross-version safe: a renamed/removed default degrades gracefully). */
export function resolveDefaultSong(catalog: CatalogEntry[]): CatalogEntry | null {
  const pinned = catalog.find((e) => e.id === CONFIG.firstRun.defaultSongId);
  if (pinned) return pinned;
  const real = catalog.filter((e) => e.difficulty !== "Drills");
  if (real.length === 0) return null;
  const lvl = (e: CatalogEntry) => e.level ?? Number.POSITIVE_INFINITY;
  return real.reduce((lo, e) => (lvl(e) < lvl(lo) ? e : lo));
}

/** Pieces eligible for the no-MIDI demo reel: real repertoire (no generated
 *  drills), intermediate band, never the starter song. Deterministic order. */
export function demoCandidates(catalog: CatalogEntry[]): CatalogEntry[] {
  const min = CONFIG.firstRun.demoMinLevel;
  return catalog
    .filter(
      (e) =>
        e.difficulty !== "Drills" &&
        e.level !== undefined &&
        e.level >= min &&
        e.id !== CONFIG.firstRun.defaultSongId,
    )
    .sort((a, b) => a.id.localeCompare(b.id));
}

/** Pick one candidate by a [0,1) RNG draw; the caller's RNG advances each call
 *  so a reel of successive picks varies. Assumes a non-empty list. */
export function pickDemo(candidates: CatalogEntry[], rng: () => number): CatalogEntry {
  const i = Math.min(candidates.length - 1, Math.floor(rng() * candidates.length));
  const pick = candidates[i];
  if (!pick) throw new Error("pickDemo called with an empty candidate list");
  return pick;
}
